export default class PolicyConfiguration {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/policyConfig";
  }

  getAllPolicyConfigurations() {
    return this.client.get(`${this.resourceUrl}`);
  }

  getPolicyTypeData() {
    return this.client.get(`${this.resourceUrl}/allPolicyTypes`);
  }

  getPolicyConfigDetails(policyKey) {
    return this.client.get(`${this.resourceUrl}/${policyKey}`);
  }

  createPolicyConfig(policyConfigData) {
    return this.client.post(`${this.resourceUrl}`, policyConfigData);
  }

  updatePolicyConfig(policyKey, policyConfigData) {
    return this.client.put(
      `${this.resourceUrl}/${policyKey}`,
      policyConfigData
    );
  }
}
